import * as React from 'react';
import PropTypes from 'prop-types';
import {Subbar, Title, PageHeader} from "ah-tools";
import {Button, Icon, Message, Segment} from "semantic-ui-react";
import ModuleEdit from "./ModuleEdit";
import {IconButton} from "../extensions";

const TARGET_FORM = 'create-module-form';

class ModuleCreate extends React.Component {
	static propTypes = {
		onCreate: PropTypes.func.isRequired,
		onBack: PropTypes.func,
		isLoading: PropTypes.bool,
		topSaveButton: PropTypes.bool
	};
	static defaultProps = {
		isLoading: false,
		topSaveButton: true
	};
	
	render = () => {
		const {onCreate, onBack, isLoading, topSaveButton} = this.props;
		return (
			<div>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Subbar align={Subbar.ALIGN_START}>
						{onBack && <IconButton onClick={onBack}>
							<Icon  name={'chevron left'}/>
						</IconButton>}
						<Title>Module anlegen</Title>
					</Subbar>
					{topSaveButton && <Button loading={isLoading} positive={true} form={TARGET_FORM}>Anlegen</Button>}
				</PageHeader>
				<Message
					info={true}
					header={'Hinweis'}
					content={'Neue Module müssen im Programmcode berücksichtigt werden. Erstellte Module...'}
				/>
				<Segment padded={'very'} basic={true}>
					<ModuleEdit onSubmit={(module) => onCreate(module)} id={TARGET_FORM}>
						{!topSaveButton && <Button positive={true} form={TARGET_FORM}>Anlegen</Button>}
					</ModuleEdit>
				</Segment>
			</div>
		);
	};
}

export default ModuleCreate;


// WEBPACK FOOTER //
// ./src/components/ModuleCreate.js